import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { getCategories } from '../../Data';
import { Global } from '../../Variables/Global';

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 6 },
  desktop1: { breakpoint: { max: 3000, min: 1200 }, items: 5 },
  desktop: { breakpoint: { max: 1200, min: 992 }, items: 4 },
  tablet: { breakpoint: { max: 993, min: 767 }, items: 3 },
  mobile1: { breakpoint: { max: 767, min: 445 }, items: 2 },
  mobile: { breakpoint: { max: 445, min: 0 }, items: 1 }
};

const CategorySlider = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    let mounted = true;

    getCategories()
      .then(res => {
        if (mounted && Array.isArray(res)) {
          setCategories(res);
        }
      })
      .catch(console.error);

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="slider category-slider mb-35 mt-4">
      <div className="container">
        <div className="section-title">
          <h3>Our Categories</h3>
        </div>

        <Carousel
          responsive={responsive}
          autoPlay={false}
          keyBoardControl
          minimumTouchDrag={80}
          renderButtonGroupOutside
          slidesToSlide={1}
          partialVisible
        >
          {categories.map(cat => {
            const url = `/Category/${cat.CategoryName}/${cat.CategoryId}`;

            return (
              <div className="single-category" key={cat.CategoryId}>
                <div className="category-image">
                  <a href={url} aria-label={cat.CategoryName}>
                    <img
                      src={Global.PHOTO_URL + cat.MenuImage}
                      alt={cat.CategoryName}
                      width="121"
                      height="121"
                      className="Category-Sliderimg"
                    />
                  </a>
                </div>

                <div className="category-title">
                  <h3>
                    <a href={url} className="RemUnderline">
                      {cat.CategoryName}
                    </a>
                  </h3>
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
    </div>
  );
};

export default CategorySlider;
